<template>
  <znl-dialog
    :visible="visible"
    :append-to-body="true"
    class="c-BulkPricing"
    width="340px"
    v-loading="disabled"
    element-loading-text="正在导入"
    :height="450"
    @close="$emit('update:visible', false)"
  >
    <p class="iconfont-box">
      <span class="pull-left title">批量定价
        <span>(未税价)</span>
      </span>
      <i
        class="iconfont icon-close"
        @click="$emit('update:visible', false)"
      ></i>
    </p>
    <div class="c-BulkPricing-editview">
      <textarea
        v-model="textareaValue"
        :style="{
          height: '350px'
        }"
        @change="textareaChangeHandler"
        placeholder="请输入型号和未税价,例如:
  LM358 0.41
  BAV99 0.042
  2N7002 0.1"
      >
      </textarea>
    </div>

    <div
      slot="footer"
      class="c-BulkPricing-footer"
    >
      <label class="footer-left-label pull-left">是否可开票:</label>
      <znl-input
        form-type="select"
        :select-options="IsInvoiceOptions"
        placeholder="不修改"
        :border="true"
        :height="30"
        width="100px"
        class="footer-left pull-left"
        v-model="TaxRate"
        :clearable="true"
        @clear="TaxRate=null"
      >
      </znl-input>

      <znl-button
        :width="80"
        :height="30"
        style-type="main"
        :disabled="disabled"
        @click="importDataHandler"
      >
        确认导入
      </znl-button>
    </div>
  </znl-dialog>
</template>
<script>
import { httpPost } from '../../assets/scripts/http';

export default {
  name: 'BulkPricing',
  props: {
    visible: Boolean,
    successHandler: Function
  },
  data() {
    return {
      textareaValue: '',
      datas: [],
      disabled: false,
      TaxRate: null,
      IsInvoiceOptions: [
        { key: 13, value: '可开票 13%' },
        { key: 3, value: '可开票 3%' },
        { key: 0, value: '不可开票' }
        // { key: null, value: '不修改' }
      ]
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$nextTick(() => {
          this.textareaValue = '';
        });
      }
    }
  },
  methods: {
    textareaChangeHandler() {
      if (this.textareaValue) {
        try {
          const DataRows = this.textareaValue.split('\n');
          if (DataRows.length > 0) {
            this.datas = [];
            DataRows.forEach(item => {
              const RegMatchRes = item.trim().match(/(.+)(\s\d+(\.\d+)?)$/);
              if (RegMatchRes) {
                this.datas.push({
                  Model: RegMatchRes[1].trim(),
                  Price: RegMatchRes[2].trim()
                });
              }
            });
          }
        } catch (error) {
          this.$erroMess('数据格式不正确');
        }
      }
    },
    groupArray(data, cols) {
      const list = [];
      let current = [];
      data.forEach(t => {
        current.push(t);
        if (current.length === cols) {
          list.push(current);
          current = [];
        }
      });

      if (current.length) {
        list.push(current);
      }
      return list;
    },
    async saveBatchSharePricesAsync(DataList, index = 0) {
      try {
        let RES = await httpPost(
          'tradeCentre/saveBatchSharePricesAsync',
          {
            Params: DataList[index],
            IsHasTax: false,
            TaxRate: this.TaxRate
          },
          { baseURL: 'res' }
        );
        if (index >= DataList.length - 1) {
          if (RES && RES.Code === 0 && RES.Data) {
            this.$emit('update:visible', false);
            this.$alert('导入成功！标准价将在8分钟内完成更新。', '提示', {
              confirmButtonText: '确定'
            });
          } else {
            this.$erroMess('保存失败');
          }
          this.disabled = false;
        } else {
          await this.saveBatchSharePricesAsync(DataList, index + 1);
        }
      } catch (error) {
        this.disabled = false;
      }
    },
    importDataHandler() {
      if (this.datas.length === 0) {
        return this.$erroMess('未填写数据');
      }
      this.disabled = true;
      const DataList = this.groupArray(this.datas, 1000);
      this.saveBatchSharePricesAsync(DataList);
    }
  }
};
</script>
<style lang="scss">
.c-BulkPricing {
  .c-BulkPricing-footer {
    // text-align: center;
    .znl-button {
      &:last-child {
        margin-left: 10px;
      }
    }
  }
  .znl-dialog__header,
  .znl-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }
  .iconfont-box {
    text-align: right;
    line-height: 50px;
    .iconfont {
      cursor: pointer;
    }
    .title {
      color: #4c4d4c;
      font-size: 16px;
      font-weight: bold;
    }
  }
  textarea {
    outline: none;
    width: 100%;
    height: 350px;
    padding: 0;
    border: 1px solid #ee7700;
    border-radius: 4px;
    resize: none;
    line-height: 20px;
    font-size: 14px;
    color: #333;
    padding: 10px;
    box-sizing: border-box;
    display: block;
    border-top-left-radius: 0;
    &::-webkit-input-placeholder {
      color: #999;
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      color: #999;
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      color: #999;
    }
    &:-ms-input-placeholder {
      color: #999;
    }
  }
  .c-BulkPricing-editview {
    padding: 0 0px 0px 0px;
    .title {
      font-size: 16px;
      color: #ff2200;
      text-align: center;
      line-height: 30px;
      font-weight: bold;
      padding-bottom: 10px;
    }
    .tiptext {
      font-size: 12px;
      font-weight: bold;
      color: #ff2200;
    }
  }
  .footer-left-label {
    margin-top: 2px;
    font-size: 12px;
    margin-right: 5px;
  }
  .footer-left {
    margin-top: 12px;
  }
}
</style>
